import { useMemo } from "react";

import { useRoleSelector } from "hooks/useSelector";
import {
  useAddTask,
  useAddTaskActivity,
  useAddTaskActivityEss,
  useAddTaskEss,
  useApproveTask,
  useApproveTaskEss,
  useArchiveTask,
  useArchiveTaskEss,
  useClientsSuggestion,
  useDeleteAttachmentTask,
  useDeleteAttachmentTaskActivity,
  useDeleteAttachmentTaskActivityEss,
  useDeleteAttachmentTaskEss,
  useDeleteTask,
  useDeleteTaskActivity,
  useDeleteTaskActivityEss,
  useDeleteTaskEss,
  useDisabledTaskRepeatSettings,
  useDisabledTaskRepeatSettingsEss,
  useEditSettingTaskDisplay,
  useEditSettingTaskDisplayEss,
  useEditStatusTask,
  useEditStatusTaskEss,
  useEditTask,
  useEditTaskActivity,
  useEditTaskActivityEss,
  useEditTaskEss,
  useEditTaskRepeatSettings,
  useEditTaskRepeatSettingsEss,
  useEnableTaskRepeatSettings,
  useEnableTaskRepeatSettingsEss,
  useRejectTask,
  useRejectTaskEss,
  useSettingTaskDisplay,
  useSettingTaskDisplayEss,
  useTask,
  useTaskActivitiesPagination,
  useTaskActivitiesPaginationEss,
  useTaskApproversSuggestion,
  useTaskApproversSuggestionEss,
  useTaskClientsSuggestionEss,
  useTaskEmployeesSuggestion,
  useTaskEmployeesSuggestionEss,
  useTaskEss,
  useTasksPagination,
  useTasksPaginationEss,
  useUnarchiveTask,
  useUnarchiveTaskEss,
  useUpdateApproverTask,
  useUpdateStatusTask,
  useUpdateStatusTaskEss,
} from "queries";

const useTaskFeature = () => {
  const role = useRoleSelector();

  const query = useMemo(() => {
    switch (role) {
      case "admin":
        return {
          getTasksPagination: useTasksPagination,
          keyTasksPagination: "tasks/pagination",
          getTask: useTask,
          keyTask: "task",
          getTaskEmployees: useTaskEmployeesSuggestion,
          getTaskClients: useClientsSuggestion,
          getTaskApprovers: useTaskApproversSuggestion,
          addTask: useAddTask,
          editTask: useEditTask,
          editStatusTask: useEditStatusTask,
          updateStatusTask: useUpdateStatusTask,
          updateApproverTask: useUpdateApproverTask,
          getTaskDisplay: useSettingTaskDisplay,
          editTaskDisplay: useEditSettingTaskDisplay,
          archiveTask: useArchiveTask,
          unarchiveTask: useUnarchiveTask,
          approveTask: useApproveTask,
          rejectTask: useRejectTask,
          deleteTask: useDeleteTask,
          deleteAttachmentTask: useDeleteAttachmentTask,
          getTaskActivitiesPagination: useTaskActivitiesPagination,
          keyTaskActivitiesPagination: "taskActivities/pagination",
          addTaskActivity: useAddTaskActivity,
          editTaskActivity: useEditTaskActivity,
          deleteTaskActivity: useDeleteTaskActivity,
          deleteAttachmentTaskActivity: useDeleteAttachmentTaskActivity,
          editTaskRepeatSettings: useEditTaskRepeatSettings,
          enableTaskRepeatSettings: useEnableTaskRepeatSettings,
          disabledTaskRepeatSettings: useDisabledTaskRepeatSettings,
        };
      case "employee":
        return {
          getTasksPagination: useTasksPaginationEss,
          keyTasksPagination: "tasks/pagination/ess",
          getTask: useTaskEss,
          keyTask: "task/ess",
          getTaskEmployees: useTaskEmployeesSuggestionEss,
          getTaskClients: useTaskClientsSuggestionEss,
          getTaskApprovers: useTaskApproversSuggestionEss,
          addTask: useAddTaskEss,
          editTask: useEditTaskEss,
          editStatusTask: useEditStatusTaskEss,
          updateStatusTask: useUpdateStatusTaskEss,
          updateApproverTask: useUpdateApproverTask,
          getTaskDisplay: useSettingTaskDisplayEss,
          editTaskDisplay: useEditSettingTaskDisplayEss,
          archiveTask: useArchiveTaskEss,
          unarchiveTask: useUnarchiveTaskEss,
          approveTask: useApproveTaskEss,
          rejectTask: useRejectTaskEss,
          deleteTask: useDeleteTaskEss,
          deleteAttachmentTask: useDeleteAttachmentTaskEss,
          getTaskActivitiesPagination: useTaskActivitiesPaginationEss,
          keyTaskActivitiesPagination: "taskActivities/pagination/ess",
          addTaskActivity: useAddTaskActivityEss,
          editTaskActivity: useEditTaskActivityEss,
          deleteTaskActivity: useDeleteTaskActivityEss,
          deleteAttachmentTaskActivity: useDeleteAttachmentTaskActivityEss,
          editTaskRepeatSettings: useEditTaskRepeatSettingsEss,
          enableTaskRepeatSettings: useEnableTaskRepeatSettingsEss,
          disabledTaskRepeatSettings: useDisabledTaskRepeatSettingsEss,
        };
      default:
        return {
          getTasksPagination: useTasksPagination,
          keyTasksPagination: "tasks/pagination",
          getTask: useTask,
          keyTask: "task",
          getTaskEmployees: useTaskEmployeesSuggestion,
          getTaskClients: useClientsSuggestion,
          getTaskApprovers: useTaskApproversSuggestion,
          addTask: useAddTask,
          editTask: useEditTask,
          editStatusTask: useEditStatusTask,
          updateApproverTask: useUpdateApproverTask,
          updateStatusTask: useUpdateStatusTask,
          getTaskDisplay: useSettingTaskDisplay,
          editTaskDisplay: useEditSettingTaskDisplay,
          archiveTask: useArchiveTask,
          unarchiveTask: useUnarchiveTask,
          approveTask: useApproveTask,
          rejectTask: useRejectTask,
          deleteAttachmentTask: useDeleteAttachmentTask,
          getTaskActivitiesPagination: useTaskActivitiesPagination,
          keyTaskActivitiesPagination: "taskActivities/pagination",
          addTaskActivity: useAddTaskActivity,
          editTaskActivity: useEditTaskActivity,
          deleteTask: useDeleteTask,
          deleteTaskActivity: useDeleteTaskActivity,
          deleteAttachmentTaskActivity: useDeleteAttachmentTaskActivity,
          editTaskRepeatSettings: useEditTaskRepeatSettings,
          enableTaskRepeatSettings: useEnableTaskRepeatSettings,
          disabledTaskRepeatSettings: useDisabledTaskRepeatSettings,
        };
    }
  }, [role]);

  return { role, query };
};

export default useTaskFeature;
